import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';

type Props = { onClose: () => void; onDone: (message: string) => void };
export function CustomerForm({ onClose }: Props) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Thêm khách hàng')} onClose={onClose} />;
}
export function CustomerImport({ onClose }: Props) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Nhập khách hàng từ CSV')} onClose={onClose} />;
}
